<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Definition" });
import "tailwindcss/tailwind.css";
import Tooltip from "../tooltip/Tooltip.svelte";
export let css = "";
export let label = void 0;
export let tooltip = void 0;
let isTooltipVisible = false;
const toggleTooltipVisibility = () => {
    isTooltipVisible = !isTooltipVisible;
};
</script>

<span
    on:mouseenter = { toggleTooltipVisibility }
    on:mouseleave = { toggleTooltipVisibility }
    on:click = { toggleTooltipVisibility }
    on:keypress = { toggleTooltipVisibility }
    class = { `${ css } cursor-pointer relative`}
>
    <slot name = 'content'>{ label }</slot>

    <Tooltip position = 'south' isVisible = { isTooltipVisible } css = 'mb-2 !w-auto !whitespace-nowrap'>
        <slot name = 'tooltip'>{ tooltip }</slot>
    </Tooltip>
</span>